import { configureChains, createClient, WagmiConfig } from 'wagmi';
import { bsc, arbitrum } from 'wagmi/chains';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createWeb3Modal } from '@web3modal/wagmi/react'
import { defaultWagmiConfig } from '@web3modal/wagmi/react/config';

const queryClient = new QueryClient();
// 1. Get projectId from https://cloud.walletconnect.com
const projectId = '079e21e7569ef30abc034ba5abd8ff99';

const metadata = {
  name: 'ClusterC',
  description: 'Be a part of the Gaming Revolution',
  url: 'https://clusterc.io/',
  icons: ['https://app.gemoo.com/share/image-annotation/661227102669619200?codeId=v6awolJXzkrLy&origin=imageurlgenerator&card=661227100345974784']
};

const chains = [bsc, arbitrum];
const config = defaultWagmiConfig({
  chains,
  projectId,
  metadata,
});

createWeb3Modal({
  metadata,
  wagmiConfig: config,
  projectId,
  enableAnalytics: true,
});

export function AppKitProvider({ children }) {
  return (
    <WagmiConfig config={config}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </WagmiConfig>
  );
}